import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/virtual',
    name: 'Virtual',
    component: () => import('../views/Virtual.vue')
  },
]
// mode:'history',
// mode:'hash',
const router = new VueRouter({
  mode:'hash',
  routes
})
export default router
